import React, {
  createContext,
  useRef,
  useEffect,
  useState,
  useReducer,
  useMemo
} from "react";
// import { Scrollbars } from 'react-custom-scrollbars';
import {
  Header,
  CartItemsList,
  ExtraModule,
  EmptyState,
  ProductDetails,
  VariantsPicker,
  BundleVariantsPicker,
  CodForm
} from "./partials";
import * as Utils from "./Utils";
import { API_GATEWAY2 } from "aws-exports";
import {
  CartItemsReducer,
  ADD_ITEM,
  SET_ITEMS,
  SET_CART_NOTE,
  ADD_UPSELL,
  REMOVE_UPSELL
} from "reducers/CartItemsReducer";
import Axios from "axios";
import Confetti from "react-confetti";
import styled from "styled-components";
import classNames from "lib/classNames";
import { useTransition, animated } from "react-spring";
import useCampaign from "hooks/useCampaign";
// import iNoBounce from 'inobounce';

export const CartContext = createContext(null);
export const CartProvider = CartContext.Provider;

const CustomScroll = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  ${
    "" /* -webkit-overflow-scrolling: ${(props) => (props.isMobile ? 'touch' : undefined)}; */
  }
  ${"" /* height: ${(props) => props.height || 'var(--app-height, 100%)'}; */}
	::-webkit-scrollbar {
    width: ${(props) => (props.isMobile ? undefined : "6px")};
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: ${(props) =>
      props.isMobile ? undefined : props.trackBg || "#ffffff"};
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${(props) =>
      props.isMobile ? undefined : props.thumbBg || "#afafaf"};
    border-radius: 3px;
  }
  /* Handle on hover 
	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
	*/
`;

const Cart = ({
  campaigns = {},
  getCampaigns,
  setCampaigns,
  shop_url = null,
  isPreview = false,
  cart_items = [],
  cart_currency,
  shop_settings,
  setShopSettings,
  close = null,
  isOpened = null,
  onInit = null,
  product_id = null,
  cart_token = null,
  forcePreview = null,
  style = {},
  showCheckoutLoading,
  showComfirmOrderLoading,
  orderCodForm,
  setOrderCodForm,
  isCodFormSubmitted,
  setIsCodFormSubmitted,
  showATUAfterText,
  cartNote = "",
  hasWriteDiscountsScope = false
}) => {
  const cart_ref = useRef(null);
  const header_ref = useRef(null);
  const [cartToken, setCartToken] = useState(cart_token);
  const scrollbars_ref = useRef(null);
  const [addedFromFbt, setAddedFromFbt] = useState([]);
  const variantsPickerOverlay_ref = useRef(null);
  const bundleVariantsPickerOverlay_ref = useRef(null);
  const [viewCartTracked, setViewCartTracked] = useState(false);
  const [showConfetti, setShowConfetti] = useState(0);
  const [active_slide, slickGoTo] = useState(0);
  const [previewed_product, setPreviewed_product] = useState(null);
  const [discountCode, setDiscountCode] = useState(null);
  const [rechargeSettings, setRechargeSettings] = useState(null);
  const [userIsTabbing, setUserIsTabbing] = useState(false);
  const [variantPickerOptions, setVariantPickerOptions] = useState({});
  const [variantsPickerShow, setVariantsPickerShow] = useState(false);
  const [bundleVariantsPickerShow, setBundleVariantsPickerShow] =
    useState(false);
  const [bundleVariantsPickerOptions, setBundleVariantsPickerOptions] =
    useState({});
  const [shopify_cart_state, dispatch] = useReducer(CartItemsReducer, {
    items: cart_items,
    cartNote,
    fbtUpsells: JSON.parse(localStorage.getItem("monster_uc_upsells") || "[]")
  });
  const [one_check_up_sell_product_id, one_check_up_sell] = useCampaign(
    "one_check_up_sell"
  )(campaigns, shopify_cart_state.items);
  const slider = {
    slickGoTo,
    active_slide
  };

  const variantsPickerTransitions = useTransition(!!variantsPickerShow, null, {
    from: { transform: "translateY(100%)", background: "rgba(0,0,0,0)" },
    enter: { transform: "translateY(0%)", background: "rgba(0,0,0,0.2)" },
    leave: { transform: "translateY(100%)", background: "rgba(0,0,0,0)" }
  });
  const bundleVariantsPickerTransitions = useTransition(
    !!bundleVariantsPickerShow,
    null,
    {
      from: { transform: "translateY(100%)", background: "rgba(0,0,0,0)" },
      enter: { transform: "translateY(0%)", background: "rgba(0,0,0,0.2)" },
      leave: { transform: "translateY(100%)", background: "rgba(0,0,0,0)" }
    }
  );
  const add_to_cart = (
    {
      variant_id,
      quantity = 1,
      product_handle = null,
      product = null,
      properties,
      selling_plan
    },
    callback = null,
    formData
  ) => {
    Utils.addToCart(
      {
        variant_id,
        quantity,
        properties,
        selling_plan,
        isPreview,
        shop_url,
        product_handle,
        product,
        currency: shop_settings.currency
      },
      formData
    ).then((item) => {
      const items = item?.items || [item];
      if (item?.items) {
        dispatch({ type: SET_ITEMS, items });
      } else {
        dispatch({ type: ADD_ITEM, item });
      }

      if (!isPreview) {
        productionAddToCartCallBack(items);
      }
      if (callback) callback(item);
    });
  };

  const productionAddToCartCallBack = async (items) => {
    items.forEach(async ({ product_id }) => {
      if (!Object.keys(campaigns).map(parseInt).includes(product_id)) {
        const response = await getCampaigns([product_id], cartToken);
        setCampaigns({ ...campaigns, ...response.campaigns });

        if (response.settings.fromCampaign || !shop_settings.modules.order) {
          setShopSettings({
            ...shop_settings,
            ...response.settings,
            modules: { ...shop_settings.modules, ...response.settings.modules }
          });
        }
        setCartToken(response.cartToken);
      }
    });
  };

  const update_cart_item = (
    { variant_id, quantity = 1, properties, selling_plan, sold_out = false },
    callback = null,
    formData
  ) => {
    const item = Utils.findItem({
      items: shopify_cart_state.items,
      variant_id: variant_id
    });
    const currentQuantity = item ? item.quantity : 0;
    if (quantity === "+1") quantity = currentQuantity + 1;
    if (quantity === "-1") quantity = currentQuantity - 1;
    Utils.updateCartItem(
      {
        variant_id,
        quantity,
        properties,
        selling_plan,
        isPreview,
        state: shopify_cart_state
      },
      formData
    )
      .then((items) => {
        if (!sold_out) {
          dispatch({ type: SET_ITEMS, items });
          const item = Utils.findItem({ items, variant_id });
          if (!item) return;
          if (!isPreview) {
            productionAddToCartCallBack([item]);
          }
          if (callback) callback(item, items);
        } else {
          dispatch({
            type: SET_ITEMS,
            items: items.map((item) => {
              if (item.variant_id === variant_id) {
                return { ...item, quantity: 0, itemSoldOut: true };
              }
              return item;
            })
          });
          // items: items.length
          // 	? items.splice(oldItems.indexOf(soldOutItem), 0, { ...soldOutItem, quantity: 0 })
          // 	: [{ ...soldOutItem, quantity: 0 }],
          if (callback) callback(null, items);
        }
      })
      .catch((error) => {
        if (callback) callback(null, null, error.response.data);
      });
  };

  const trackEvent = (data) => {
    return isPreview
      ? Promise.resolve(null)
      : Axios({
          method: "post",
          url: `${API_GATEWAY2}/public/track`,
          params: {
            shop: shop_url
          },
          data
        });
  };

  const preview_product = (product, showAddCartButton = true) => {
    setPreviewed_product({ ...product, showAddCartButton });
    slider.slickGoTo(1);
  };
  const productAddedToCart = (product) => {
    const product_id = typeof product === "object" ? product.id : product;
    return shopify_cart_state.items
      .map((item) => item.product_id)
      .includes(parseInt(product_id));
  };
  const productNotAddedToCart = (product) => !productAddedToCart(product);

  const get_total = (type = null, items = null) => {
    const filteredItems = (items || shopify_cart_state.items).filter((item) => {
      if (
        one_check_up_sell &&
        item.product_id.toString() === one_check_up_sell?.product?.id
      ) {
        return !!one_check_up_sell?.include_in_atu;
      }
      return true;
    });
    const original = Utils.getTotal(items || shopify_cart_state.items);
    const filteredItemsTotal = Utils.getTotal(
      items || shopify_cart_state.items
    );
    const discount = Utils.getDiscount({
      items: items || shopify_cart_state.items,
      filteredItems,
      filteredItemsTotal,
      campaigns: campaigns || {},
      total: original,
      discountCode
    });
    const subtotal = original - discount;
    const output = { original, discount, subtotal };
    return type ? output[type] : output;
  };

  const productionAddToCart = (
    items,
    { variant_id, quantity, selling_plan, properties },
    callback,
    formData
  ) => {
    const item = items.find(({ id }) => id === parseInt(variant_id));
    if (item) {
      update_cart_item(
        {
          variant_id,
          quantity: item.quantity + quantity,
          properties,
          selling_plan
        },
        (item, items) => {
          if (callback) callback(item, items);
        },
        formData
      );
    } else {
      add_to_cart(
        { variant_id, quantity, properties, selling_plan },
        (item) => {
          if (callback) callback(item, items.concat([item]));
        },
        formData
      );
    }
  };

  const hasFont =
    shop_settings.font.custom && shop_settings.font.family
      ? shop_settings.font.family
      : false;

  const handleFirstTab = ({ keyCode }) => {
    if (keyCode === 9) {
      setUserIsTabbing(true);
      window.removeEventListener("keydown", handleFirstTab);
    }
  };
  // const handleResize = () => {
  // 	// setWindowHeight(window.innerHeight);
  // 	document.documentElement.style.setProperty('--screen-width', `${window.innerWidth}px`);
  // 	document.documentElement.style.setProperty('--screen-height', `${window.innerHeight + 60}px`);
  // };

  useEffect(() => {
    if (onInit) onInit(productionAddToCart);
    // handleResize();
    window.addEventListener("keydown", handleFirstTab);
    // window.addEventListener('resize', handleResize);
    // window.addEventListener('orientationchange', handleResize);
    // window.addEventListener('scroll', handleResize);
    // window.addEventListener('gesturechange', handleResize);
    return () => {
      window.removeEventListener("keydown", handleFirstTab);
      // window.removeEventListener('resize', handleResize);
      // window.removeEventListener('orientationchange', handleResize);
      // window.removeEventListener('scroll', handleResize);
      // window.removeEventListener('gesturechange', handleResize);
    };
  }, []);

  useEffect(() => {
    if (hasFont && window.WebFont) {
      // window.WebFontConfig = {
      // 	loading: function () {
      // 		console.log("loading");
      // 	},
      // 	active: function () {
      // 		console.log("active");
      // 	},
      // 	inactive: function () {
      // 		console.log("inactive");
      // 	},
      // 	fontloading: function (...args) {
      // 		console.log("fontloading", args);
      // 	},
      // 	fontactive: function (...args) {
      // 		console.log("fontactive", args);
      // 	},
      // 	fontinactive: function (...args) {
      // 		console.log("fontinactive", args);
      // 	}
      // };
      window.WebFont.load({
        google: {
          families: [hasFont]
        }
      });
    }
  }, [hasFont]);

  const addFBTUpsell = (id) => {
    dispatch({ type: ADD_UPSELL, id });
  };

  const removeFBTUpsell = (id) => {
    dispatch({ type: REMOVE_UPSELL, id });
  };

  const setCartItems = (items) => dispatch({ type: SET_ITEMS, items });
  const setCartNote = (cartNote) => dispatch({ type: SET_CART_NOTE, cartNote });
  const getRechargeSettings = async () => {
    try {
      const { data } = await Axios.get(
        `https://static.rechargecdn.com/store/${shop_url}/product/2020-12/products.json`
      );
      setRechargeSettings(data);
    } catch (error) {
      console.log("recharge is not installed");
      setRechargeSettings(undefined);
    }
  };
  useEffect(() => {
    const atcs = document.querySelectorAll("button[data-pf-type='ProductATC']");
    atcs.forEach((atc) => {
      atc.setAttribute("type", "submit");
      atc.removeAttribute("data-pf-type");
      atc.removeAttribute("data-product-id");
      atc.removeAttribute("data-checkout");
    });
    setCartItems(cart_items);
    if (rechargeSettings === null) getRechargeSettings();
  }, [cart_items]);

  useEffect(() => {
    if (!isPreview) return;

    if (forcePreview) {
      preview_product(forcePreview);
    } else if (
      window.location.pathname === "/settings/checkout" &&
      !shop_settings?.cod_settings?.is_form_in_cart
    ) {
      slider.slickGoTo(1);
    } else {
      slider.slickGoTo(0);
    }
  }, [isPreview, forcePreview, shop_settings?.cod_settings?.is_form_in_cart]);

  useEffect(() => {
    if (window.location.pathname === "/settings/checkout")
      slider.slickGoTo(
        shop_settings.cod_settings &&
          shop_settings?.cod_settings?.is_form_in_cart
          ? 0
          : 1
      );
  }, [
    shop_settings.cod_settings,
    shop_settings?.cod_settings?.is_form_in_cart
  ]);

  useEffect(() => {
    // if (isOpened) iNoBounce.enable();
    // else iNoBounce.disable();
    if (isOpened && !viewCartTracked) {
      const campaignsIds = Object.values(campaigns)
        .flat(Infinity)
        .map((c) => {
          // console.log(c);
          const { campaign_key } = c;
          return campaign_key && campaign_key[1];
        })
        .filter(Boolean);
      trackEvent({
        type: "view_cart",
        campaigns: campaignsIds
      }).then((_) => {
        setViewCartTracked(true);
      });
    }
  }, [isOpened, viewCartTracked]);

  let stickyElements;
  return (
    <CartProvider
      value={{
        campaigns,
        shopify_cart_items: shopify_cart_state.items,
        shopify_cart_upsells: shopify_cart_state.fbtUpsells,
        cartNote: shopify_cart_state.cartNote,
        setCartItems,
        cart_currency,
        cart_ref,
        slider,
        cart_settings: shop_settings,
        Utils,
        add_to_cart,
        update_cart_item,
        preview_product,
        get_total,
        isPreview,
        previewed_product,
        setPreviewed_product,
        shop_url,
        productNotAddedToCart,
        productAddedToCart,
        scrollbars_ref: scrollbars_ref.current,
        close,
        discountCode,
        setDiscountCode,
        productionAddToCart,
        isOpened,
        trackEvent,
        cart_token: cartToken,
        setShowConfetti,
        setVariantPickerOptions,
        setVariantsPickerShow,
        setBundleVariantsPickerShow,
        setBundleVariantsPickerOptions,
        showCheckoutLoading,
        showComfirmOrderLoading,
        orderCodForm,
        setOrderCodForm,
        isCodFormSubmitted,
        setIsCodFormSubmitted,
        showATUAfterText,
        setCartNote,
        addFBTUpsell,
        removeFBTUpsell,
        rechargeSettings,
        hasWriteDiscountsScope
      }}
    >
      <div
        className={classNames(
          "w-full h-full m-0 p-0 max-w-full flex flex-col relative",
          {
            "disable-outline": !userIsTabbing
          }
        )}
        ref={cart_ref}
        style={{
          color: Utils.formatColor(shop_settings.font.color),
          background: Utils.formatColor(shop_settings.theme.background),
          fontSize: shop_settings.font.size,
          fontFamily: hasFont ? hasFont.split(":")[0] : "inherit",
          direction: shop_settings.rtl ? "rtl" : "ltr"
        }}
      >
        {cart_ref.current && showConfetti !== 0 && (
          <Confetti
            width={cart_ref.current.offsetwidth}
            height={cart_ref.current.offsetHeight}
            recycle={false}
            numberOfPieces={showConfetti}
            gravity={0.2}
            onConfettiComplete={() => setShowConfetti(0)}
            initialVelocityX={5}
          />
        )}
        <Header title="My Cart" headerRef={header_ref} />
        <CustomScroll
          ref={scrollbars_ref}
          thumbBg={Utils.formatColor(shop_settings.theme.secondary)}
          trackBg={Utils.formatColor(shop_settings.theme.background)}
          isMobile={Utils.isMobile()}
          className={classNames("flex-1")}
          style={
            {
              // paddingBottom: '60px',
            }
          }
        >
          <div
            style={{ minHeight: "100%" }}
            className={classNames(
              "slider w-full min-w-full flex-1 overflow-hidden flex flex-col"
            )}
          >
            <div
              className={classNames(
                "flex-1 flex transform transition-transform duration-300 ease-out",
                {
                  "translate-x-full": active_slide && shop_settings.rtl,
                  "-translate-x-full": active_slide && !shop_settings.rtl,
                  "translate-x-0": !active_slide
                }
              )}
            >
              {shopify_cart_state.items.length ? (
                <div
                  className={classNames(
                    "w-full min-w-full flex flex-col h-auto"
                  )}
                >
                  <CartItemsList />
                  {shop_settings.cod_settings &&
                    shop_settings.cod_settings.is_active &&
                    shop_settings?.cod_settings?.is_form_in_cart && <CodForm />}
                  {shop_settings.modules.order &&
                    shop_settings.modules.order.map((key, i) => (
                      <ExtraModule
                        key={key}
                        moduleKey={key}
                        modules={shop_settings.modules}
                        cartNote={shopify_cart_state.cartNote}
                      />
                    ))}
                </div>
              ) : (
                <EmptyState />
              )}

              <ProductDetails
                style={{
                  maxHeight:
                    active_slide === 0 && header_ref.current
                      ? `calc(100vh - ${header_ref.current.offsetHeight}px)`
                      : undefined
                }}
              />
              {(isPreview ||
                (shop_settings.cod_settings &&
                  shop_settings.cod_settings.is_active)) && <CodForm />}
            </div>
          </div>
          {/* </div> */}
          {/* </Slider> */}
        </CustomScroll>

        {variantsPickerTransitions.map(({ item, key, props }) => {
          const { background, ...restProps } = props;
          return (
            item && (
              <div key={key} className={classNames("absolute inset-0 z-20")}>
                <animated.div
                  className={classNames(
                    "flex flex-col justify-end w-full h-full overflow-hidden"
                  )}
                  ref={variantsPickerOverlay_ref}
                  onClick={(event) => {
                    if (event.target === variantsPickerOverlay_ref.current)
                      setVariantsPickerShow(false);
                  }}
                  style={{ background }}
                >
                  <animated.div
                    style={restProps}
                    className={classNames("max-h-full animated-variant-picker")}
                  >
                    <VariantsPicker
                      {...variantPickerOptions}
                      CustomScroll={CustomScroll}
                      parentRef={variantsPickerOverlay_ref}
                    />
                  </animated.div>
                </animated.div>
              </div>
            )
          );
        })}

        {bundleVariantsPickerTransitions.map(({ item, key, props }) => {
          const { background, ...restProps } = props;
          return (
            item && (
              <div key={key} className={classNames("absolute inset-0 z-20")}>
                <animated.div
                  className={classNames(
                    "flex flex-col justify-end w-full h-full overflow-hidden"
                  )}
                  ref={bundleVariantsPickerOverlay_ref}
                  onClick={(event) => {
                    if (
                      event.target === bundleVariantsPickerOverlay_ref.current
                    )
                      setBundleVariantsPickerShow(false);
                  }}
                  style={{ background }}
                >
                  <animated.div
                    style={restProps}
                    className={classNames("max-h-full")}
                  >
                    <BundleVariantsPicker
                      {...bundleVariantsPickerOptions}
                      CustomScroll={CustomScroll}
                      parentRef={bundleVariantsPickerOverlay_ref}
                    />
                  </animated.div>
                </animated.div>
              </div>
            )
          );
        })}
      </div>
    </CartProvider>
  );
};

export default Cart;
